import { ComponentProps } from "react";
import { MenuSelectBody } from "./menu-select-body";
import { MenuSelectItem } from "./menu-select-item";
import { MenuSelectSection } from "./menu-select-section";
import { MenuSelectTitle } from "./menu-select-title";

export type MenuSelectProps = ComponentProps<"div">;

export function MenuSelect({ ...props }: MenuSelectProps) {
  return <div {...props} />;
}

export namespace MenuSelect {
  export const Section = MenuSelectSection;
  export const Title = MenuSelectTitle;
  export const Item = MenuSelectItem;
  export const Body = MenuSelectBody;
}
